import { environment } from "src/environments/environment";

interface ILoginPagemodel {
  username: string;
  password: string;
  isInfoPopup: boolean;
  APIServer:string;
}
export class LoginPagemodel implements ILoginPagemodel {
  constructor() {
    this.username = "";
    this.password = "";
    this.APIServer = environment.APIServer;
  }
  username: string;
  password: string;
  isInfoPopup: boolean;
  APIServer:string;
}